<template>
  <div class="tab-item">
    <div class="item" v-for="item in data" :key="item.id">
      <div class="novel-container" v-if="item.data_type === 'ugc_item' && item.type===2"
           @click="showDetailItem(item)">
        <div class="novel-cover" @click="showDetailItem(item)">
          <img v-lazy="item.cover_url"/>
        </div>
        <div class="novel-info">
          <div class="novel-title-box">
            <div class="novel-title">{{item.title}} <span v-if="item.type === 8"> <Tag type="danger" plain class="comic-tag">漫画</Tag> </span>
            </div>
            <div class="rate-container" @click.stop="toComment(item)" v-if="item.rate_desc">
              <div class="rate-main">
                <div class="rate-value" v-if="item.rate_value">{{item.rate_value.toFixed(1)}}</div>
                <Rate readonly size="14" color="#ffd21e" v-model="item.rate_value"></Rate>
              </div>
              <div class="rate-desc">
                {{item.rate_desc}}
              </div>
            </div>
            <div class="novel-actions">
              <div class="comment-actions" @click.stop="toComment(item)">
                <icon-svg icon-class="feedback" style="font-size: 16px;"></icon-svg>
                <div class="comment-count" v-if="item.comment_count">{{item.comment_count}}</div>
              </div>
              <div class="book-shelf-actions">
                <BookShelfAction :item="item"></BookShelfAction>
              </div>
            </div>
          </div>
          <div class="novel-description">{{item.description}}</div>
        </div>
      </div>
      <div class="novel-container" v-if="item.type === 8" @click="showDetailItem(item)">
        <div class="comic-cover">
          <img v-lazy="item.cover_url"/>
        </div>
        <div class="novel-info">
          <div class="novel-title-box">
            <div class="novel-title">
              {{item.title}} <span class="tag-comic" v-if="item.type === 8"></span>
            </div>
            <div class="rate-container" @click.stop="toComment(item)" v-if="item.rate_desc">
              <div class="rate-main">
                <div class="rate-value" v-if="item.rate_value">{{item.rate_value.toFixed(1)}}</div>
                <Rate readonly size="14" color="#ffd21e" v-model="item.rate_value"></Rate>
              </div>
              <div class="rate-desc">
                {{item.rate_desc}}
              </div>
            </div>
            <div class="novel-actions">
              <div class="comment-actions" @click.stop="toComment(item)">
                <icon-svg icon-class="feedback" style="font-size: 16px;"></icon-svg>
                <div class="comment-count" v-if="item.comment_count_desc">{{item.comment_count_desc}}</div>
              </div>
              <div class="book-shelf-actions">
                <BookShelfAction :item="item"></BookShelfAction>
              </div>
            </div>
          </div>
          <div class="comic-description">{{item.description}}</div>
        </div>
      </div>

      <div class="video-container" v-if="item.data_type === 'ugc_item' && item.type === 0"
           @click="showDetailItem(item)">
        <div class="item-detail">
          <div class="img-container">
            <img v-lazy="item.cover_url" alt="" class="video-cover-img">
            <div class="desc">
              <div class="description"> {{item.title}}</div>
            </div>
            <div class="mask"></div>
            <img class="play-icon" src="https://a1.wanwanshequ.com/static/public/play.png"/>
            <div class="duration"> {{getDuration(item)}}</div>
          </div>
        </div>
      </div>

      <div class="movie-container" v-if="item.data_type === 'ugc_item' && (item.type===4 || item.type === 5)"
           @click="showDetailItem(item)">
        <div class="movie-cover">
          <img v-lazy="item.cover_url"/>
        </div>
        <div class="movie-description">
          <div>
            <div class="movie-title">{{item.title}}</div>
          </div>
          <ul class="movie-info">
            <li class="description-container">
              简介：<span>{{item.description}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {ugcItemTypeMovie, ugcItemTypeSeries, ugcItemTypeComic, ugcItemTypeComicWt} from "../../util/const";
  import {Tag, Rate} from "vant"
  import BookShelfAction from "../common/BookShelfAction";

  export default {
    name: "MixItemList",
    components: {
      BookShelfAction,
      Tag, Rate
    },
    props: {
      data: {
        type: Array,
        default: () => []
      },
    },
    methods: {
      showDetailItem(item) {
        if (item.type === 2) {
          this.$router.push('/novel/' + item.id);
        } else if (item.type === 0) {
          this.$router.push('/video/' + item.id);
        } else if (item.type === ugcItemTypeMovie || item.type === ugcItemTypeSeries) {
          this.$router.push("/movie/" + item.id)
        } else if (item.type === ugcItemTypeComic || item.type === ugcItemTypeComicWt) {
          this.$router.push("/comic/" + item.id)
        }
      },

      onAuthorInfo() {
      },

      getDuration(item) {
        let t = item.duration
        if (Math.floor(t / 3600) > 0) {
          return ('0' + Math.floor(t / 3600) % 24).slice(-2) + ':' + ('0' + Math.floor(t / 60) % 60).slice(-2) + ':' + ('0' + t % 60).slice(-2)
        } else {
          return ('0' + Math.floor(t / 60) % 60).slice(-2) + ':' + ('0' + t % 60).slice(-2)
        }
      },

      toRate(item) {
        this.$router.push("/rate/item/" + item.id)
      },

      toComment(item) {
        this.$router.push("/comment/" + item.id)
      }
    },
    computed: {}
  };
</script>

<style lang="scss" scoped>
  .tab-item {
    display: flex;
    flex-direction: column;

    .item {
      width: 100%;

      .novel-container {
        display: flex;
        background: white;
        padding: 12px 4px;
        overflow: hidden;
        border-bottom: 1px solid #fafafa;
      }

      .movie-container {
        display: flex;
        background: white;
        margin: 2px 0;
        padding: 10px 8px;
        overflow: hidden;
        border-bottom: 1px solid #fafafa;
      }
    }

    .novel-cover {
      position: relative;
      width: 100px;
      height: 140px;
      margin-left: 4px;
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;

      img {
        height: 140px;
        position: absolute;
      }
    }

    .comic-cover {
      position: relative;
      width: 180px;
      height: 110px;
      margin-left: 4px;
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;

      img {
        height: 110px;
        position: absolute;
      }
    }

    .rate-container {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      line-height: 1.5;
      margin-top: 8px;

      .rate-main {
        display: flex;
        align-items: center;
        margin-right: 12px;

        .rate-value {
          font-size: 20px;
          font-weight: bold;
          margin-right: 8px;
        }
      }

      .rate-desc {
        font-size: 12px;
      }
    }

    .novel-info {
      padding: 5px 28px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: grey;

      .novel-title-box {

        .novel-actions {
          margin-top: 8px;
          display: flex;
          align-items: center;

          .comment-actions {
            font-size: 14px;
            display: flex;
            align-items: center;
            min-width: 18px;
            flex: 0 1 45%;

            .comment-count {
              margin-left: 5px;
              font-size: 14px;
            }
          }

          .book-shelf-actions {
            margin-left: 15px;
          }
        }

      }

      .novel-title {
        display: flex;
        align-items: center;
        font-size: 14px;
        /*font-weight: bold;*/
        color: #565656;
        line-height: 1.5;
      }

      .novel-description {
        margin-top: 12px;
        color: rgba(0, 0, 0, 0.75);
        font-size: 12px;
        line-height: 1.5;
        max-height: 90px;
        display: -webkit-box;
        -webkit-line-clamp: 3; /*显示3行，超出的用省略号代替*/
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .comic-description {
        margin-top: 12px;
        color: rgba(0, 0, 0, 0.75);
        font-size: 12px;
        line-height: 1.5;
        max-height: 90px;
        display: -webkit-box;
        -webkit-line-clamp: 2; /*显示3行，超出的用省略号代替*/
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .novel-options {
        display: flex;
        align-items: center;

        .tags {
          font-size: 12px;
          flex: 1 1 auto;
          width: 70%;
        }

        .tag-item {
          margin-right: 8px;
          margin-bottom: 5px;
        }

        .option {
        }
      }
    }

    .video-container {
      margin: 2px 0;
      padding: 4px 0;
      background: white;
      border-bottom: 1px solid #fafafa;

      .item-detail {
        background-color: #fff;
        margin: 2px 0;

        .img-container {
          height: 180px;
          margin: 0 auto;
          position: relative;
          overflow: hidden;

          .video-cover-img {
            width: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            display: block;
            transform: translate(-50%, -50%);
          }
        }

        .desc {
          position: absolute;
          z-index: 1;
          top: 0;
          left: 0;
          color: white;
          height: 40px;
          display: flex;
          margin: 5px 10px;
          font-size: 16px;
          overflow: hidden;
          font-weight: bold;
          line-height: 1.2;

          .description {
            margin: 3px 5px;
          }
        }
      }

      .mask {
        position: absolute;
        top: 0;
        left: 0;
        height: 60%;
        width: 100%;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.8), transparent);
      }

      .play-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 44px;
        height: 44px;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
      }

      .duration {
        position: absolute;
        right: 8px;
        bottom: 8px;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        height: 18px;
        min-width: 18px;
        color: #fff;
        border-radius: 5px;
        background: rgba(0, 0, 0, 0.7);
        line-height: 12px;
        text-align: center;
        font-size: 10px;
        padding: 3px 3px;
        vertical-align: bottom;
      }
    }


    .movie-cover {
      flex: 0 0 auto;
      width: 120px;
      height: 170px;
      overflow: hidden;
      border-radius: 5px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .movie-description {
      padding: 5px 10px;
      position: relative;

      .movie-title {
        font-size: 18px;
        font-weight: bold;
        color: #222;
      }

      .movie-info {
        margin-top: 5px;
        font-size: 12px;
        line-height: 1.5;

        .description-container {
          max-height: 90px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3; /*显示3行，超出的用省略号代替*/
          -webkit-box-orient: vertical;
        }
      }

      .tags-movie-container {
        display: flex;
        margin-top: 5px;
        align-items: center;
        justify-content: space-between;
      }

      .recommend-tag {
      }

      ul li {
        color: grey;
        margin-top: 3px;

        span {
          color: rgba(0, 0, 0, 0.69);
        }
      }
    }
  }
</style>
